(function () {
  const roots = document.querySelectorAll("[data-toda-reference]");
  if (!roots.length) return;

  const cartUrlRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function moveReviewsBeforeCommunity(root) {
    const anchor = root.querySelector("[data-toda-reviews-anchor]");
    if (!anchor || !anchor.parentNode) return true;

    const reviewWidget = document.querySelector("#judgeme_product_reviews, .jdgm-review-widget");
    const reviewsSection =
      document.querySelector('.shopify-section[id$="__reviews"]') ||
      (reviewWidget && reviewWidget.closest(".shopify-section"));

    if (!reviewsSection || root.contains(reviewsSection)) return false;

    reviewsSection.classList.add("toda-pdp__reviews-section");
    anchor.parentNode.insertBefore(reviewsSection, anchor);
    anchor.remove();
    return true;
  }

  function hideDuplicateCategoryStream(root) {
    const duplicateStream = Array.from(
      document.querySelectorAll(".kuuraii-category-stream:not(.toda-pdp__related)")
    ).find(function (stream) {
      return !root.contains(stream);
    });
    if (!duplicateStream) return;

    const sectionWrapper = duplicateStream.closest(".shopify-section");
    (sectionWrapper || duplicateStream).hidden = true;
  }

  roots.forEach(function (root) {
    const isTodaPdp = root.classList.contains("kuuraii-toda-pdp");

    hideDuplicateCategoryStream(root);
    if (!moveReviewsBeforeCommunity(root) && "MutationObserver" in window) {
      const reviewsObserver = new MutationObserver(function () {
        if (moveReviewsBeforeCommunity(root)) reviewsObserver.disconnect();
      });
      reviewsObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () {
        reviewsObserver.disconnect();
      }, 10000);
    }

    const toast = root.querySelector(".toast");
    const countEl = root.querySelector("[data-toda-cart-count]");
    let toastTimer;

    function notify(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add("show");
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove("show");
      }, 1300);
    }

    function setCount(count) {
      if (!countEl || typeof count !== "number") return;
      countEl.textContent = String(count);
    }

    root.querySelectorAll("[data-toda-wish]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        button.classList.toggle("is-active");
      });
    });

    function setFramePlaying(video, isPlaying) {
      const frame = video && video.closest("[data-toda-video-toggle]");
      if (!frame) return;
      frame.classList.toggle("is-playing", Boolean(isPlaying));
    }

    function syncAudioToggle(video) {
      const frame = video && video.closest("[data-toda-video-toggle]");
      const button = frame && frame.querySelector("[data-toda-audio-toggle]");
      if (!button) return;
      const isUnmuted = !video.muted;
      button.classList.toggle("is-unmuted", isUnmuted);
      button.setAttribute("aria-pressed", String(isUnmuted));
      button.setAttribute("aria-label", isUnmuted ? "Mute video" : "Turn sound on");
    }

    function ensureInitialMute(video) {
      if (!video || video.dataset.todaAudioStarted === "true") return;
      video.muted = true;
      video.setAttribute("muted", "");
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.dataset.todaAudioStarted = "true";
      syncAudioToggle(video);
    }

    function prepareAudioForUserPlay(video) {
      if (!video) return;
      if (isTodaPdp) {
        video.muted = false;
        video.removeAttribute("muted");
        video.dataset.todaAudioStarted = "true";
        syncAudioToggle(video);
        return;
      }
      ensureInitialMute(video);
    }

    function playVideo(video, userInitiated) {
      if (!video) return;
      root.querySelectorAll("video").forEach(function (otherVideo) {
        if (otherVideo !== video) {
          otherVideo.pause();
          setFramePlaying(otherVideo, false);
        }
      });
      if (userInitiated) {
        prepareAudioForUserPlay(video);
      } else {
        ensureInitialMute(video);
      }
      const playRequest = video.play();
      if (playRequest && typeof playRequest.catch === "function") {
        playRequest
          .then(function () {
            setFramePlaying(video, true);
          })
          .catch(function () {});
      } else {
        setFramePlaying(video, true);
      }
    }

    root.querySelectorAll("[data-toda-video-toggle]").forEach(function (frame) {
      const video = frame.querySelector("video[data-toda-video], video");
      if (!video) return;
      const clickOnly = frame.hasAttribute("data-toda-click-video") || video.hasAttribute("data-toda-click-video");
      frame.setAttribute("role", "button");
      frame.setAttribute("tabindex", "0");
      video.addEventListener("play", function () {
        setFramePlaying(video, true);
        syncAudioToggle(video);
      });
      video.addEventListener("pause", function () {
        setFramePlaying(video, false);
      });
      video.addEventListener("ended", function () {
        setFramePlaying(video, false);
      });
      const audioToggle = frame.querySelector("[data-toda-audio-toggle]");
      if (audioToggle) {
        audioToggle.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          video.muted = !video.muted;
          if (video.muted) {
            video.setAttribute("muted", "");
          } else {
            video.removeAttribute("muted");
          }
          syncAudioToggle(video);
        });
      }
      const playToggle = frame.querySelector("[data-toda-play-toggle]");
      if (playToggle) {
        playToggle.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!video.paused && !video.ended) {
            video.pause();
          } else {
            playVideo(video, true);
          }
        });
      }
      ensureInitialMute(video);
      if (!video.paused && !video.ended) setFramePlaying(video, true);
      frame.addEventListener("click", function () {
        if (clickOnly && !video.paused && !video.ended) {
          video.pause();
          return;
        }
        playVideo(video, true);
      });
      frame.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        if (clickOnly && !video.paused && !video.ended) {
          video.pause();
          return;
        }
        playVideo(video, true);
      });
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;
            if (entry.isIntersecting) {
              ensureInitialMute(video);
              const playRequest = video.play();
              if (playRequest && typeof playRequest.catch === "function") {
                playRequest.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.45 }
      );

      root.querySelectorAll("video[data-toda-video]").forEach(function (video) {
        if (video.hasAttribute("data-toda-click-video") || video.closest("[data-toda-click-video]")) return;
        observer.observe(video);
      });
    }

    root.querySelectorAll("[data-toda-product-form]:not([data-collection-quick-add='true'])").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        const button = form.querySelector(".add-button");
        if (button && button.disabled) return;
        if (button) button.disabled = true;

        fetch(cartUrlRoot + "cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to add item");
            return fetch(cartUrlRoot + "cart.js", { headers: { Accept: "application/json" } });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to read cart");
            return response.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
            if (button) {
              button.classList.add("is-added");
              window.setTimeout(function () {
                button.classList.remove("is-added");
              }, 800);
            }
            notify("Added to cart");
          })
          .catch(function () {
            notify("Please open the product to add it");
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    });
  });
})();
